import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Tabbar, TabbarItem } from 'vant';
import 'lib-flexible/flexible'
import '@/permission'

import '@/assets/css/style.css'

Vue.config.productionTip = false

Vue.use(Tabbar);
Vue.use(TabbarItem);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
